/**
 * Decodifica texto vindo da API com entidades HTML escapadas (ex.: &amp;, &lt;, &gt;).
 * Destina-se à exibição como texto plano (não interpreta marcação HTML).
 */
export function decodeHtmlEntities(value) {
  if (value == null) return value;
  if (typeof value !== "string") return value;
  if (!value.includes("&")) return value;

  if (typeof document !== "undefined") {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = value;
    return textarea.value;
  }

  return value
    .replace(/&nbsp;/g, "\u00a0")
    .replace(/&#(\d+);/g, (m, n) => {
      const code = Number(n);
      return Number.isFinite(code) && code >= 0 ? String.fromCharCode(code) : m;
    })
    .replace(/&#x([0-9a-f]+);/gi, (m, h) => {
      const code = parseInt(h, 16);
      return Number.isFinite(code) && code >= 0 ? String.fromCharCode(code) : m;
    })
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'");
}
